<div id="guides-overlay" class="guides-overlay">
  <div class="controls">
    <button type="button" class="guides-close" data-close="true" data-dismiss="modal" aria-label="{{t 'closeModal'}}">
      <span>&times;</span>
    </button>
  </div>
  <div class="guides">
    {{#each guides}}
      <div class="guide" style="position: absolute; opacity: 0.3; z-index: 10; left: 50%;transform: translateX(-50%);{{style this}}"></div>
    {{/each}}
  </div>
</div>
